import { module } from 'modujs';
import { gsap } from '../gsap';

export default class EntriesList extends module {

    static get settings() {
        return {
            VISIBLE_CLASS: 'is-visible'
        }
    }

    constructor(m) {
        super(m);

        this.$wrapper = this.$('wrapper')[0]
        this.$items = this.$('item')
        this.$assets = Array.from(this.$('asset'))

        this.activeIndex = -1
    }

    init() {

        // Set sizes
        this.setSizes()

        this.el.addEventListener('mousemove', this.onMouseMove = e => this.mouseMove(e))

        this.itemsEvents = []
        let hover
        this.$items.forEach(($item, i) => {
            hover = () => this.hover(i)
            this.itemsEvents.push(hover)
            $item.addEventListener('mouseenter', this.itemsEvents[i])
        })

        // Resize event
        window.addEventListener('resizeEnd', this.onResize = () => this.setSizes())
    }

    mouseMove(e) {
        const rect = this.el.getBoundingClientRect();

        let x = (e.clientX - rect.left)/rect.width;
        let y = (e.clientY - rect.top)/rect.height;

        x = this.wrapper.width * (x - this.wrapper.offsetX)
        y = y * (rect.height - this.wrapper.height)

        gsap.to(this.$wrapper, {
            x,
            y,
            duration: .4,
            ease: 'power2.out'
        })
    }

    hover(index) {

        // Return if same as active asset
        if(this.activeIndex === index) {
            return
        }

        if(this.activeIndex >= 0) {
            this.$assets[this.activeIndex].classList.remove(EntriesList.settings.VISIBLE_CLASS)
        }

        this.$assets[index].classList.add(EntriesList.settings.VISIBLE_CLASS)

        this.activeIndex = index
    }

    setSizes() {
        // Wrapper
        this.wrapper = {
            width: this.$wrapper.offsetWidth,
            height: this.$wrapper.offsetHeight,
            offsetX: window.innerWidth >= 1000 ? 0.5 : 1
        }
    }

    destroy() {
        this.el.removeEventListener('mousemove', this.onMouseMove)

        this.$items.forEach(($item, i) => {
            $item.removeEventListener('mouseenter', this.itemsEvents[i])
        })

        window.removeEventListener('resizeEnd', this.onResize)
    }
}
